import 'babel-polyfill'
import {AUTH} from '@/store/types'
import router from '@/router'
import security from '@/security'
import utils from '@/utils/utils'
import strings from '@/strings'

export default {
  namespaced: true,
  state: {
    user: null,
    isAuthenticated: false
  },
  getters: {
    user (state) {
      return state.user
    },
    userEmail (state) {
      return state.user && state.user.profile ? state.user.profile.email : ''
    },
    isAuthenticated (state) {
      return state.isAuthenticated
    },
    userName (state) {
      return state.user && state.user.profile ? state.user.profile.name : ''
    },
    role (state) {
      let roles = state.user && state.user.profile ? state.user.profile.role : ''
      let finalRole = ''
      if (Array.isArray(roles)) {
        roles.forEach((role) => {
          if (role === strings.roles.serviceDesk && finalRole === '') {
            finalRole = strings.roles.serviceDesk
          } else if (role === strings.roles.clientAdmin) {
            finalRole = strings.roles.clientAdmin
          } else if (role === strings.roles.globalAdmin) {
            finalRole = strings.roles.globalAdmin
          }
        })
        return finalRole
      } else {
        return roles
      }
    },
    isAdmin (state, getters) {
      return getters.role === strings.roles.clientAdmin || getters.role === strings.roles.globalAdmin
    },
    isGlobalAdmin (state, getters) {
      return getters.role === strings.roles.globalAdmin
    },
    isServiceDesk (state, getters) {
      return getters.role === strings.roles.serviceDesk
    }
  },
  mutations: {
    [AUTH.SET_USER] (state, value) {
      state.user = value
    },
    [AUTH.SET_AUTHENTICATED] (state, value) {
      state.isAuthenticated = value
    }
  },
  actions: {
    signIn () {
      security.signinRedirect()
    },
    async signinCallback () {
      await security.signinRedirectCallback()
      router.push('/')
    },
    async authenticate ({dispatch}) {
      let user = await dispatch('getUser') // see if the user details are in local storage
      if (user) {
        if (user.expired) {
          // Se expirado efetua o login novamente
          dispatch('Global/showLoading', null, {root: true})
          dispatch('signIn')
        } else {
          dispatch('setAuthenticated', true)
          let clientId = utils.getJwtClaim(user.access_token, 'client_desk4me_id')
          dispatch('Client/setClientId', clientId, {root: true})
          dispatch('setUser', user)
          // From singing or firts open, load initial settings
          if (router.history.current.name === 'SignIn' || !router.history.current.name) {
            await dispatch('loadInitialData', (await user).access_token)
          }
        }
      }
    },
    async getUser () {
      try {
        let user = await security.getUser()
        return user
      } catch (err) {
      }
    },
    async loadInitialData ({dispatch}) {
      dispatch('Global/showLoading', null, {root: true})
      /* analytics.ga('set', 'userId', user.profile.email) // Set the user ID using signed-in user_id.
     analytics.ga('send', 'event', 'authentication', 'user-id available') */
    },
    signout () {
      security.signoutRedirect()
    },
    setAuthenticated ({commit}, auth) {
      commit(AUTH.SET_AUTHENTICATED, auth)
    },
    setUser ({commit}, user) {
      commit(AUTH.SET_USER, user)
    }
  }
}
